import React from "react";

const Projects = () => {
  const projects = [
    {
      name: "NearTreat",
      desc: "A hyperlocal platform connecting street food lovers with nearby vendors — making it easy to discover, explore, and support the hidden gems of street food culture around you.",
      domain: "Full Stack Web Development (MERN)",
      technology: "React.js, Node.js, Express.js, MongoDB, Google Maps API, Firebase, Tailwind CSS",
      website: "https://neartreat.vercel.app/",
    },
    {
      name: "JustPrompt.in",
      desc: "An AI-powered, voice-first no-code website builder that lets small and medium businesses create stunning websites simply by talking. Supports 22+ languages with real-time website generation — no coding required.",
      domain: "Generative AI & Full Stack Web Development",
      technology: "React.js, Node.js, MongoDB, LLMs, Voice AI, Gemini API, Bhashini, Tailwind CSS",
      website: "https://www.justprompt.in/",
    },
    {
      name: "Docvoxia",
      desc: "An AI-powered multilingual voice-to-text transcription platform for OPD prescriptions. Supports FHIR & SNOMED-CT healthcare standards and integrates with NextGen eHospital and ABDM for seamless digital health documentation.",
      domain: "Healthcare AI & Generative AI",
      technology: "React.js, Node.js, MongoDB, LLMs, Voice AI, Bhashini, FHIR, SNOMED-CT",
      website: "https://docvoxia.justprompt.in/",
    },
    {
      name: "Docvoxia CV",
      desc: "A hands-free, AI-powered resume builder that generates ATS-friendly professional CVs through speech recognition. Users simply speak naturally and the platform crafts a polished resume — no typing needed.",
      domain: "Generative AI & Full Stack Web Development",
      technology: "React.js, Node.js, MongoDB, LLMs, Voice AI (Speech Recognition), Bhashini, Tailwind CSS",
      website: "https://docvoxia-cv.justprompt.in/",
    },
    {
      name: "CROSS-Intelligence",
      desc: "A cross-border regulatory oversight and strategic solutions intelligence platform that empowers local businesses to navigate global trade using AI-driven insights, RAG-based research, and multilingual support.",
      domain: "Generative AI, RAG & Multilingual NLP",
      technology: "React.js, Node.js, MongoDB, LLMs, RAG, Vector Embeddings, Bhashini, Tailwind CSS",
      website: "https://cross-intelligence.vercel.app/",
    },
    {
      name: "TimelyTask",
      desc: "A task management and payment platform built to simplify job scheduling and fair compensation for blue-collar workers — bridging the gap between workers and employers with a transparent, easy-to-use interface.",
      domain: "Full Stack Web Development (MERN)",
      technology: "React.js, Node.js, Express.js, MongoDB, Tailwind CSS",
      website: "https://timelytask.vercel.app/",
    },
    {
      name: "QRMedisync",
      desc: "A smart QR code-based drug dispensing system combining embedded hardware and web technologies to automate and secure medication distribution in healthcare settings.",
      domain: "Embedded Systems & IoT",
      technology: "React.js, Node.js, Express.js, MongoDB, NodeMCU (ESP8266), Servo Motor, QR Code Scanner",
      website: "https://qr-medisync.vercel.app/",
    },
    {
      name: "Dan Jr. Wedding Biryani's",
      desc: "A fully designed responsive UI/UX concept for a fictional biryani ordering platform — focused on warm visual identity, intuitive ordering flow, and a rich food-brand experience.",
      domain: "UI/UX Design",
      technology: "Figma, Canva",
      website:
        "https://www.figma.com/file/O2i8m8dQwE0wGwVFTHIyIE/Guvi?type=design&mode=design&t=1uoaxXFFlklvsimj-1",
    },
    {
      name: "GreenBite",
      desc: "A minimalist UI/UX design for a fictional organic food delivery service — crafted around clean layouts, earthy tones, and a calm user experience that reflects sustainable and healthy living.",
      domain: "UI/UX Design",
      technology: "Figma, Canva",
      website:
        "https://www.figma.com/file/dIma8LQf84proswVjLVmGw/GreenBite?type=design&mode=design&t=m1S3OnyD6Sx8uIgR-1",
    },
    {
      name: "StuTrack AI",
      desc: "An AI-powered competitive programming tracker that monitors coding problem-solving progress for students in a department — helping educators identify top performers and students who need support.",
      domain: "AI & Web Development",
      technology: "React.js, Tailwind CSS, AI/ML Analytics",
      website: "https://stutrackai.vercel.app/",
    },
    {
      name: "Smart Ambulance Control System",
      desc: "An IoT-based intelligent traffic control system that dynamically clears ambulance routes using real-time GPS tracking and ECG vitals monitoring — reducing emergency response times in urban healthcare.",
      domain: "Embedded Systems & IoT",
      technology: "Arduino Uno, ESP32, GPS Module, ECG Module, C/C++",
    },
  ];

  return (
    <>
      <section id="projects" className="py-14">
        <div className="max-w-screen-xl mx-auto px-4 text-gray-600 md:px-8">
          <div className="relative max-w-xl mx-auto sm:text-center">
            <h3 className="text-gray-800 text-3xl font-semibold sm:text-4xl">
              Explore some of my notable Projects
            </h3>
            <div className="mt-3 max-w-xl">
              <p>Innovations in Technology and Leadership</p>
            </div>
          </div>
          <div className="mt-16 justify-center gap-6 sm:grid sm:grid-cols-2 sm:space-y-0 lg:grid-cols-3">
            {projects.map((item, idx) => (
              <div
                key={idx}
                className={`relative flex-1 flex items-stretch flex-col rounded-xl border-2 mt-6 sm:mt-0 ${
                  item.isMostPop ? "mt-10" : ""
                }`}
              >
                {item.isMostPop ? (
                  <span className="w-32 absolute -top-5 left-0 right-0 mx-auto px-3 py-2 rounded-full border shadow-md bg-white text-center text-gray-700 text-sm font-semibold">
                    Most popular
                  </span>
                ) : (
                  ""
                )}
                <div className="p-8 space-y-4 border-b">
                  <span className="text-yellow-600 font-medium">
                    {item.name}
                  </span>
                  <p>{item.desc}</p>
                  <button
                    className="px-3 py-3 rounded-lg w-full font-semibold text-sm duration-150 text-white bg-customYellow hover:bg-yellow-500 active:bg-Yellow-700"
                    onClick={() =>
                      window.open(
                        item.website || item.videoURL || "#",
                        "_blank"
                      )
                    }
                  >
                    Project Link
                  </button>
                </div>
                <div className="p-8 space-y-3">
                  <p className=" text-gray-800 font-medium">Domain</p>
                  <p>{item.domain}</p>
                  <p className=" text-gray-800 font-medium">Tech Stack</p>
                  <p>{item.technology}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Projects;